<script lang="ts">
  import { type IconType } from "$components/+blocks/OVIcon/OVIcon";

  export let icon: IconType;
  export let size: string = "size-4";
  let className: string = "";
  export { className as class };
</script>

<svelte:component
  this={icon}
  width={undefined}
  height="100%"
  class="{size} {className}"
  aria-hidden="true"
  {...$$restProps}
/>
